module.exports = __webpack_public_path__ + "static/ta_logo_flat-7e60a388aeb5f5bf5d849677d3fb1288.png";